import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import "../styleAllBlogs.css";

import compostFlower from "../../../assets/img/flourishingGarden1.jpg";
import bloomingSoil from "../../../assets/img/flowers.jpg";


export default function FlowerGardenSoilBlog() {
  const location = useLocation();

  useEffect(() => {
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    const linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) {
      linkTag.setAttribute("href", canonicalUrl);
    } else {
      const newLinkTag = document.createElement("link");
      newLinkTag.setAttribute("rel", "canonical");
      newLinkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(newLinkTag);
    }

    const newTitle = "The Secret to a Flourishing Flower Garden: Soil Health Comes First Blog";
    document.title = newTitle;

    const newDescription =
      "Discover why healthy soil is the key to a vibrant flower garden. Learn composting tips, pH balance, and essential nutrients for stunning blooms.";
    const descriptionMetaTag = document.querySelector('meta[name="description"]');
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", newDescription);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "description");
      newMetaTag.setAttribute("content", newDescription);
      document.head.appendChild(newMetaTag);
    }

    const newKeywords = [
      "Flower garden soil tips, Compost for flower beds, Soil pH for flowers, Organic flower garden, Garden soil Vancouver, Healthy soil for flowers, Soil amendments for blooms, Soil texture and drainage, Mycorrhizal fungi garden, Nutrient cycling soil, Best compost for flowers, Flower fertilizer organic, Soil care flower gardening, Soil life and biodiversity, Garden soil testing, Gardening with compost mulch, Vancouver flower gardening tips, Improve soil structure for blooms"
    ].join(", ");

    const keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      const newMetaTag = document.createElement("meta");
      newMetaTag.setAttribute("name", "keywords");
      newMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(newMetaTag);
    }

    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", newTitle);
    } else {
      const newOgTitleTag = document.createElement("meta");
      newOgTitleTag.setAttribute("property", "og:title");
      newOgTitleTag.setAttribute("content", newTitle);
      document.head.appendChild(newOgTitleTag);
    }

    const ogDescriptionTag = document.querySelector('meta[property="og:description"]');
    if (ogDescriptionTag) {
      ogDescriptionTag.setAttribute("content", newDescription);
    } else {
      const newOgDescriptionTag = document.createElement("meta");
      newOgDescriptionTag.setAttribute("property", "og:description");
      newOgDescriptionTag.setAttribute("content", newDescription);
      document.head.appendChild(newOgDescriptionTag);
    }
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <div className="beforeSection"></div>
      <div className="sectionBlogpost flourishingGarden">
        <a href="/blog" className="backPosts">
          <i className="bi bi-arrow-left"></i>
          Back
        </a>
        <article>
          <header>
            <h1>
              <div className="nth-line-1" data-aos="fade-up">
                The Secret to a Flourishing
              </div>
              <div className="nth-line-2" data-aos="fade-up">
                Flower Garden: Soil Health Comes First
              </div>
            </h1>
          </header>
          <hr />
          <section data-aos="fade-right">
            <p>
              When you picture a vibrant flower garden bursting with color, it’s easy to focus on blooms. But healthy soil is the real secret behind those lush displays.
            </p>
            <p>
              <span>Why Soil Health Matters</span><br />
              Healthy soil supports strong roots, helps flowers resist disease, and fuels bigger, longer-lasting blooms. It acts as a living reservoir for water and nutrients.
            </p>
            <p>
              <span>The Living Soil Ecosystem</span><br />
              One teaspoon of healthy soil contains up to a billion microbes. These organisms recycle nutrients, improve soil structure, and build resilience for your garden.
            </p>
            <p>
              <span>Soil Texture and Structure</span><br />
              Loamy soil—balanced with sand, silt, and clay—is best for flowers. It drains well but holds enough moisture and nutrients for healthy growth.
            </p>
            <img loading="lazy" src={bloomingSoil} alt="Healthy loamy soil supporting blooming flowers" className="imgblog" />
            <p>
              <span>Soil pH and Flower Health</span><br />
              Most flowers prefer a pH between 6.0–7.0. Soil tests help you maintain the right balance and avoid nutrient lockout.
            </p>
            <p>
              <span>Compost: The Soil Supercharger</span><br />
              Use compost in two ways:<br />
              <strong>• Mix into soil</strong> before planting to improve structure and boost nutrients.<br />
              <strong>• Use as mulch</strong> to retain moisture and feed the soil over time.
            </p>
            <img loading="lazy" src={compostFlower} alt=" flower garden" className="imgblog" />
            <p>
              <span>Key Flowering Nutrients</span><br />
              Phosphorus promotes blooms. Potassium boosts color and resilience. Trace elements like zinc and boron play vital roles too.
            </p>
            <p>
              <span>Tips for Healthy Flower Garden Soil</span><br />
              • Avoid over-tilling to protect soil life<br />
              • Rotate flowers each season<br />
              • Add compost regularly<br />
              • Test and amend soil pH<br />
            </p>
            <p>
              Treat your soil like a living foundation, and your flowers will thank you with beauty that lasts season after season. Feed the soil—and it will feed your blooms.
            </p>
          </section>
        </article>
        <div className="relatedArticles">
          <h3>Related Articles</h3>
          <ul>
            <li><a href="/blog/creating-a-pollinator-and-native-plant-garden">Creating a Pollinator and Native Plant Garden</a></li>
            <li><a href="/blog/saving-the-bees">Saving the Bees</a></li>
            <li><a href="/blog/spring-garden-cleanup-guide-for-greater-vancouver">Spring Garden Cleanup Guide for Greater Vancouver</a></li>
          </ul>
        </div>
        <div className="secondBanner">
          <div className="container" data-aos="fade-down">
            <div className="row">
              <div className="col-md-6">
                <h3>Ready to elevate your outdoor experience?</h3>
                <p>
                  Fill out our contact page, and let our expert landscaping team
                  bring your vision to life with a personalized estimate
                  tailored to your unique preferences and needs.
                </p>
              </div>
              <div className="col-md-6 ">
                <div className="call-to-action text-right">
                  <a href="/contact-us" className="get-a-quote">
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
